/** @module Specification/BOM/ProductSwitchboard */
define([
	"dojo/_base/declare",
	"csi/store/_base",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare, csiStore, MultiSelectSwitchboard) {

	// FIX - this could probably be generalized to control matrix columns in any view with a matrix

	return declare(MultiSelectSwitchboard, {
		idViewProperty: null,
		disableButtonAction: true,
		refreshStoreOptions: true,
		productSizeName: null,
		productStoreName: null,

		canShowPlugin: function() {
			// summary: return true if more than one size
			return this.store && this.store.query().length > 1;
		},

		postCreate: function() {
			// summary: refresh the store when the color nodes are known
			const view = this.getView();

			view.watch(this.productStoreName, () => {
				this.refreshStore(this.getViewPropertyValue());
			});

			view.watch(this.productSizeName, (attr, oldVal, newVal) => {
				this.set("label", newVal);
			});

			this.inherited(arguments);
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		},

		/**
		 * @override
		 * If no data, then store should be empty, and thus the switchboard should not be displayed
		 */
		_getStoreOptions: function(url, r) {
			var store = this.getView().get(this.productStoreName);
			if (store) {
				var data = store.query().map(csiStore.nameObject);

				return {
					bSort: false,
					data
				};
			}

			return null;
		}
	});
});